import {putDataInDevCenterDataStore} from '../../app/store';

function getConfigurationJsonDataAndStoreInDataStore(configurationData, hostname){
    const skeletonItems = {}
    var defaultProcessor = "";
    var processorMap = new Map();
    for(var key in configurationData[hostname]['processors']) {
        processorMap.set(key, configurationData[hostname]['processors'][key]['processor'])
    }
    defaultProcessor = configurationData[hostname]['defaultProcessor'];
    skeletonItems["apiHostURL"] = configurationData[hostname]['apiHostURL'];
    skeletonItems["apiProdURL"] = configurationData[hostname]['apiProdURL'];
    skeletonItems['hostname'] = hostname;
    skeletonItems["signUpURL"] = configurationData[hostname]['signUpURL'];
    skeletonItems['merchantId'] = configurationData[hostname]['processors'][defaultProcessor]['merchantId'];
    skeletonItems["processor"] = defaultProcessor;
    skeletonItems["processorMap"] = processorMap;
    skeletonItems["defaultMerchant"] = true;
    skeletonItems["authentication"] = configurationData[hostname]['processors'][defaultProcessor]['authentication'];
    skeletonItems["partnerName"] = configurationData[hostname]['partnerName'];
    skeletonItems["partnerFullName"] = getBrandName() != "" ? getBrandName() : configurationData[hostname]['partnerFullName'];
    skeletonItems["allConfigurationData"] = configurationData[hostname];

    storeConfigurationDataStoreContents(skeletonItems);
}

//retreive Cybs/Partner Brand Full Name from brand-name element which is added/authored through AEM
function getBrandName() {
    var partnerBrandNameJsonElement = document.getElementById("brand-name");
    if (null != partnerBrandNameJsonElement) {
        var brandName = partnerBrandNameJsonElement.getAttribute("data-attribute");
        if (brandName && brandName.length > 0) {
            brandName = decodeURIComponent(brandName);
            return brandName;
        }
    }
    return "";
}

function storeConfigurationDataStoreContents(skeletonItems)
{
    putDataInDevCenterDataStore({type:'UPDATE_ALL_CONFIGURATION_DATA', allConfigurationData: skeletonItems["allConfigurationData"]});
    putDataInDevCenterDataStore({type:'UPDATE_API_HOST_URL',apiHostURL:skeletonItems["apiHostURL"]});
    putDataInDevCenterDataStore({type:'UPDATE_API_PROD_URL',apiProdURL:skeletonItems["apiProdURL"]});
    putDataInDevCenterDataStore({type:'UPDATE_SIGN_UP_URL',signUpURL:skeletonItems["signUpURL"]});
    putDataInDevCenterDataStore({type:'UPDATE_HOSTNAME',hostname:skeletonItems["hostname"]});
    putDataInDevCenterDataStore({type:'UPDATE_PARTNER_NAME',partnerName:skeletonItems["partnerName"]});
    putDataInDevCenterDataStore({type:'UPDATE_PARTNER_FULL_NAME',partnerFullName:skeletonItems["partnerFullName"]});
    putDataInDevCenterDataStore({type:'UPDATE_MERCHANT_ID',merchantId:skeletonItems["merchantId"]});
    putDataInDevCenterDataStore({type:'UPDATE_PROCESSOR_MAP',processorMap:skeletonItems["processorMap"]});
    putDataInDevCenterDataStore({type:'UPDATE_PROCESSOR',processor:skeletonItems["processor"]});
    putDataInDevCenterDataStore({type:'UPDATE_PROCESSOR_NAME',processorName:skeletonItems["processorMap"].get(skeletonItems["processor"])});
    putDataInDevCenterDataStore({type:'UPDATE_DEFAULT_MERCHANT',defaultMerchant:skeletonItems["defaultMerchant"]});
    // putDataInDevCenterDataStore({type:'UPDATE_AUTHENTICATION',authentication:skeletonItems["authentication"]});
    // putDataInDevCenterDataStore({type:'UPDATE_HTTP_SIGNATURE',httpSignature:skeletonItems["authentication"]["httpSignature"]});
    putDataInDevCenterDataStore({type:'UPDATE_KEY_ID',keyId:skeletonItems["authentication"]["httpSignature"]["keyId"]});
    putDataInDevCenterDataStore({type:'UPDATE_SECRET_KEY',secretKey:skeletonItems["authentication"]["httpSignature"]["secretKey"]});
    // putDataInDevCenterDataStore({type:'UPDATE_JWT',jwt:skeletonItems["authentication"]["jwt"]});
    putDataInDevCenterDataStore({type:'UPDATE_P12KEY',p12Key:skeletonItems["authentication"]["jwt"]["p12Key"]});
    putDataInDevCenterDataStore({type:'UPDATE_HEADER_PARAM_DEFAULTS',headerParamDefaults:skeletonItems["headerParamDefaults"]});
}

function storeConfigData(){
    var fileName = window.location.hostname;
        // replace file name with proper file name 
        if (fileName != null) {
            fileName = fileName.replaceAll(".", "-");
        }
    const configData = require('../../dist/json/credentials/' + fileName);
    getConfigurationJsonDataAndStoreInDataStore(configData, window.location.hostname);
}

export default getConfigurationJsonDataAndStoreInDataStore;
export {storeConfigurationDataStoreContents, storeConfigData};